var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-overflow",staticStyle:{"max-height":"600px"}},[_c('textarea',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"taskTemplate"}},[_vm._v(" "+_vm._s(_vm.taskTemplateJson)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }